import { render, staticRenderFns } from "./ResultsListItem.vue?vue&type=template&id=3b128652&scoped=true&lang=pug"
import script from "./ResultsListItem.vue?vue&type=script&lang=js"
export * from "./ResultsListItem.vue?vue&type=script&lang=js"
import style0 from "./ResultsListItem.vue?vue&type=style&index=0&id=3b128652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b128652",
  null
  
)

export default component.exports